export const dateFormat = "dd-MM-yyyy";
export const dateFormat2 = "DD-MM-YYYY";
